module.exports = __webpack_public_path__ + "img/news_6.b5a0ab64.png";